export default __webpack_public_path__ + "img/cNxlgNzq.400f4761.svg";